module.exports = __webpack_public_path__ + "img/help_icon.fa203f2d.svg";